export const withUrlParams = (url: string, params: Record<string, string>): string => {
  const urlObj = new URL(url);
  for (const [paramKey, paramVal] of Object.entries(params)) {
    urlObj.searchParams.append(paramKey, paramVal);
  }
  return urlObj.toString();
};
